import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";

/**
 * Grade de fotos de aluno.
 * - showAluno: exibe nome/código do aluno (fotos de vários alunos).
 * - showAno: exibe o chip do ano letivo.
 * - onOpenFoto(index): abre a foto no visualizador.
 */
const AlunoFotoList = ({ listaAF, showAluno = false, showAno = true, onOpenFoto }) => (
  <Box display="grid" gridTemplateColumns="repeat(auto-fill, minmax(170px, 1fr))" gap={2}>
    {listaAF.map((af, index) => (
      <Card key={af.codigo ?? index} variant="outlined" sx={{ borderRadius: 2 }}>
        <ButtonBase
          onClick={() => af.foto && onOpenFoto?.(index)}
          disabled={!af.foto}
          aria-label={af.foto ? `Ampliar foto ${af.anoLetivo ?? ""}` : undefined}
          sx={{ display: "block", width: "100%" }}
        >
          <Box
            sx={{
              aspectRatio: "3 / 4",
              bgcolor: "action.hover",
              color: "text.disabled",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {af.foto ? (
              <Box
                component="img"
                src={af.foto}
                alt={af.aluno?.nome ? `Foto de ${af.aluno.nome}` : "Foto do aluno"}
                loading="lazy"
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <ImageNotSupportedOutlinedIcon fontSize="large" />
            )}
          </Box>
        </ButtonBase>
        <Box px={1.5} py={1} display="flex" alignItems="center" gap={1} minWidth={0}>
          {showAno && af.anoLetivo && <Chip size="small" label={af.anoLetivo} />}
          {showAluno && af.aluno && (
            <Typography variant="caption" noWrap title={af.aluno.nome}>
              {af.aluno.codAlunoEscola ? `${af.aluno.codAlunoEscola} · ` : ""}
              {af.aluno.nome}
            </Typography>
          )}
        </Box>
      </Card>
    ))}
  </Box>
);

export default AlunoFotoList;
